import { eventQBus } from "../types/EventQBus";
import ExperimentsProvider from "../utils/Experiments";
import { OnTileLoaded } from "../types/Tile";
import { OnTooltipClose } from "../types/Assets";
import { cookie } from "@otto-ec/global-resources/cookie";

let toolTipAdded = false;
let experimentsProvider: ExperimentsProvider;

const moreOptionsExperimentId = "e927";
const moreOptionsValidVariationsBottom = ["ColTooltip", "Col"];
const moreOptionsWithToolTop = ["ColTooltip", "TitTooltip"];

const moreOptionsClass = "reptile_tile__moreOptions";
const moreOptionsTextClass = "reptile_tile__moreOptions--text";

export type ClickTrackingLabels = {
  "wk.san_DimensionCount"?: string;
};

function getModifierDependingOnExperimen() {
  const currentVariation = experimentsProvider.getActiveVariation(moreOptionsExperimentId);
  let modifier = "placeholderTop";
  if (currentVariation && moreOptionsValidVariationsBottom.includes(currentVariation)) {
    modifier = "placeholderBottom";
  }

  return modifier;
}

function onTooltipClose(event: OnTooltipClose) {
  if (event.id === "moreOptions") {
    cookie.set("moreOptionsTooltipDismissed", "true");
  }
}

function tryAddToolTip(elements: HTMLCollection) {
  const tooltipDismissed = cookie.get("moreOptionsTooltipDismissed");

  if (tooltipDismissed === "true" || toolTipAdded || elements.length === 0) return;

  const currentVariation = experimentsProvider.getActiveVariation(moreOptionsExperimentId);
  if (currentVariation && moreOptionsWithToolTop.includes(currentVariation)) {
    toolTipAdded = true;

    const element = elements[0] as HTMLSpanElement;
    element.classList.add("js_openTooltip");
    element.dataset.tooltipText =
      "Dieses Produkt ist in weiteren Varianten verfügbar. Anpassungen sind auf der Produktseite möglich.";
    element.dataset.tooltipId = "moreOptions";
    element.dataset.tooltipOpenOnLoad = "true";

    setTimeout(() => {
      eventQBus.on("assets.tooltip.closed", onTooltipClose);
      eventQBus.emit("assets.tooltip.init", `.${moreOptionsClass}`);
    }, 500);
  }
}

function copyMoreOptions(event: OnTileLoaded) {
  const variationTile = event.target as HTMLElement;
  const options: HTMLElement | null = document.getElementById(`reptile-more-options-${event.variationId}`);

  if (!!options) {
    const modifier = getModifierDependingOnExperimen();
    const target = variationTile.getElementsByClassName(`${moreOptionsClass}--${modifier}`);
    if (target.length == 1) {
      const div = document.createElement("div");
      div.classList.add(moreOptionsClass);
      div.innerHTML = options.outerHTML;
      target[0].replaceWith(div);

      tryAddToolTip(variationTile.getElementsByClassName(moreOptionsTextClass));
    }
  }
}

export function registerMoreOptions() {
  experimentsProvider = new ExperimentsProvider();
  const showMoreOptionsClass = document.getElementsByClassName("reptile_searchResult--showMoreOptions");

  if (showMoreOptionsClass.length > 0) {
    eventQBus.on("ftfind.tile.loaded", copyMoreOptions);
  }
}
